<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <page-header
          :page="headerConfig"
          :actions="headerActionsConfig"
          left-side-class="col-md-8 page-header__extended--left-side"
          right-side-class="col-md-4 d-flex align-items-end justify-content-end mb-2"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <validation-observer ref="searchForm" tag="form">
          <filter-manager
            :display-advanced="false"
            class="filter-manager_extended"
            search-container-class="search-btn"
            search-icon="fa fa-sync"
            search-text="Procesar"
            v-model="model.filters"
            :filters="filterManagerConfig"
            @search="onHandlerSearch"
          />
        </validation-observer>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-lg-6">
        <iframe
          id="fred"
          title="PDF in an i-Frame"
          :src="`${model.pdf}#toolbar=0&navpanes=0&scrollbar=0`"
          frameborder="0"
          scrolling="auto"
          class="pdf-iframe"
        ></iframe>
      </div>
      <div class="col-lg-6">
        <div class="p-4 border rounded" v-if="rows.length">
          <h3 class="mb-3">Campos extraidos del documento:</h3>
          <p>
            <span class="font-weight-bold mr-2">Periodo:</span>
            <span
              >{{ model.data.period }}
              {{ !model.data.hasSameStudentPeriod ? "*" : "" }}</span
            >
          </p>
          <p>
            <span class="font-weight-bold mr-2">Numero de Sie: </span
            ><span
              >{{ model.data.sie }}
              {{ !model.data.hasSameStudentSie ? "*" : "" }}</span
            >
          </p>
          <p>
            <span class="font-weight-bold mr-2">Servicio:</span>
            <span
              >{{ model.data.service }}
              {{ !model.data.hasSameStudentService ? "*" : "" }}</span
            >
          </p>
          <p class="font-weight-bold">Visitas:</p>
          <table class="table bordered table-bordered mb-2">
            <thead>
              <tr>
                <th
                  v-for="(cell, idx) in headerCells"
                  :key="idx"
                  :colspan="cell.columnSpan || 1"
                  :rowspan="cell.rowSpan || 1"
                >
                  {{ cell.content || "" }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
                <td
                  v-for="(cell, columnIndex) in row"
                  :key="columnIndex"
                  :colspan="cell.columnSpan || 1"
                  :rowspan="cell.rowSpan || 1"
                >
                  {{ cell.content || "" }}
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            <span class="font-weight-bold mr-2"
              >Total de visitas para pago:</span
            >
            {{ model.data.visitsCount }} {{ !hasSameVisitNumber ? "*" : "" }}
          </p>
          <p class="font-weight-bold mb-0">Firmas Identificadas:</p>
          <div class="signature">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="hasSignature(model.data.therapistSignature)"
              id="flexCheckDisabled"
              disabled
            />
            <span>Terapista:</span>
          </div>
          <div class="signature">
            <span>Proveedor:</span>
            <input
              class="form-check-input"
              type="checkbox"
              :checked="hasSignature(model.data.providerSignature)"
              id="flexCheckDisabled"
              disabled
            />
          </div>
          <div class="signature">
            <span>Padre:</span>
            <input
              class="form-check-input"
              type="checkbox"
              :checked="hasSignature(model.data.parentSignature)"
              id="flexCheckDisabled"
              disabled
            />
          </div>
          <p class="mt-2">
            <span class="font-weight-bold mr-2"
              >Porciento de Confiabilidad:</span
            >
            <span>{{ percentOfConfidence }}%</span>
          </p>
          <p class="font-weight-bold">
            Resultado del analisis del documento:
          </p>
          <div class="width-fit border rounded py-2 px-3">
            <span class="font-weight-bold">{{ documentIsApproved }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import FilterManager from "FilterManager";
import processCertificationMonthlyServices from "@/services/processCertificationMonthlyServices";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";

export default {
  name: "ProcessCertificationMonthlyServicesMain",
  mixins: [alertMixin],
  components: {
    PageHeader,
    FilterManager
  },
  data() {
    return {
      model: {
        filters: {
          academicYearId: null,
          monthNumber: null,
          disciplineTypeId: null,
          studentSieId: null
        },
        pdf: null,
        data: {
          sie: "",
          period: "",
          service: "",
          therapistSignature: false,
          providerSignature: false,
          parentSignature: false,
          hasSameStudentSie: false,
          hasSameStudentPeriod: false,
          hasSameStudentService: false,
          hasSameVisitNumber: false,
          visitsCount: 0
        },
        confidence: 0
      },
      tableData: {}
    };
  },
  computed: {
    headerConfig() {
      return {
        title: "Proceso de Certificación de Servicios Mensuales",
        icon: "fas fa-history",
        routes: ["Inicio", "Proceso de Certificación de Servicios Mensuales"]
      };
    },
    headerActionsConfig() {
      return [
        {
          text: "Regresar",
          icon: "fas fa-arrow-circle-left pr-2",
          variant: "success ml-0",
          click: () => this.$router.push("/operations")
        }
      ];
    },
    filterManagerConfig() {
      return [
        {
          name: "academicYearId",
          component: "CustomInput",
          type: "text",
          placeholder: "Año académico",
          class: "col-12 col-md-3",
          value: this.model.filters.academicYearId
        },
        {
          name: "monthNumber",
          component: "CustomInput",
          type: "text",
          placeholder: "Período",
          class: "col-12 col-md-3",
          value: this.model.filters.monthNumber
        },
        {
          name: "disciplineTypeId",
          component: "CustomInput",
          type: "text",
          placeholder: "Servicio",
          class: "col-12 col-md-3",
          value: this.model.filters.disciplineTypeId
        },
        {
          name: "studentSieId",
          component: "CustomInput",
          type: "text",
          placeholder: "SIE",
          class: "col-12 col-md-3",
          value: this.model.filters.studentSieId
        }
      ];
    },
    hasSignature() {
      return signature => {
        return signature != null;
      };
    },
    headerCells() {
      return this.tableData?.cells
        ?.filter(cell => cell.rowIndex === 0)
        .map(e => ({
          columnSpan: e.columnSpan,
          content: e.content,
          rowSpan: e.rowSpan
        }));
    },
    rows() {
      const rows = [];

      for (let rowIndex = 1; rowIndex <= this.tableData.rowCount; rowIndex++) {
        const row = [];
        for (
          let columnIndex = 0;
          columnIndex < this.tableData.columnCount;
          columnIndex++
        ) {
          const cell = this.getCell(rowIndex, columnIndex);
          if (columnIndex == 4 && cell && cell.content) {
            cell.content = cell.content.replace(":unselected", "");
          }
          if (Object.keys(cell).length) row.push(cell);
        }
        rows.push(row);
      }

      return rows.map(row => {
        return row.map(cell => {
          return {
            columnSpan: cell.columnSpan,
            content: cell.content,
            rowSpan: cell.rowSpan
          };
        });
      });
    },
    percentOfConfidence() {
      return this.model.confidence * 100;
    },
    hasSameVisitNumber() {
      return this.model.data?.hasSameVisitNumber;
    },
    documentIsApproved() {
      return this.model.data.successfullyApprovedAttendance &&
        this.model.data.isApproved
        ? "Aprobado"
        : "No aprobado";
    }
  },
  methods: {
    async onHandlerSearch() {
      const { data } = await processCertificationMonthlyServices
        .search({ ...this.model.filters })
        .catch(err =>
          this.ShowToast("Error", err.response.data.message, "error")
        );
      if (data) {
        this.model.pdf = this.base64ToByteArray(data.content);
        this.model.confidence = data.confidence;
        for (const [key, value] of Object.entries(data)) {
          if (value.content) this.model.data[key] = value.content;
          else if (value.cells) {
            this.tableData = value;
          } else {
            this.model.data[key] = value;
          }
        }
      }
    },
    getCell(rowIndex, columnIndex) {
      return (
        this.tableData.cells.find(
          cell =>
            cell.rowIndex === rowIndex &&
            cell.columnIndex === columnIndex &&
            cell.hasOwnProperty("content")
        ) || {}
      );
    },
    base64ToByteArray(base64String) {
      var byteCharacters = atob(base64String);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], { type: "application/pdf" });
      return URL.createObjectURL(blob);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .page-header__extended {
    &--left-side {
      .tag-badge {
        margin-bottom: 1rem;
      }
      .controls-wrap {
        display: none;
      }
    }
  }
  .filter-manager_extended {
    border-radius: 0.25rem;
    @media only screen and (min-width: 750px) {
      .search-btn {
        &.col-lg-3 {
          flex: 0 0 10%;
          max-width: 10%;
          padding-left: 0;
        }
      }
    }
  }
}

.pdf-iframe {
  width: 100%;
  height: 950px;
  border: none;
}

.signature {
  margin-left: 1rem;
  width: fit-content;
  display: flex;
  flex-direction: row-reverse;
  & span {
    margin-right: 2rem;
  }
}

.width-fit {
  width: fit-content;
}
</style>
